/**
 * Apply RTL/LTR styles and attributes based on current language
 */
export const applyRTLStyles = (language) => {
  const htmlElement = document.documentElement;
  const bodyElement = document.body;
  
  if (language === 'ar') {
    // Apply RTL
    htmlElement.setAttribute('dir', 'rtl');
    htmlElement.setAttribute('lang', 'ar');
    bodyElement.style.direction = 'rtl';
    bodyElement.classList.add('rtl');
    bodyElement.classList.remove('ltr');
    
    // Load Arabic fonts
    loadArabicFonts();
  } else {
    // Apply LTR
    htmlElement.setAttribute('dir', 'ltr');
    htmlElement.setAttribute('lang', 'en');
    bodyElement.style.direction = 'ltr';
    bodyElement.classList.add('ltr');
    bodyElement.classList.remove('rtl');
  }
};

/**
 * Load Arabic fonts for better typography
 */
const loadArabicFonts = () => {
  // Check if fonts are already loaded
  if (document.getElementById('arabic-fonts')) {
    return;
  }
  
  const link = document.createElement('link');
  link.id = 'arabic-fonts';
  link.href = 'https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Tajawal:wght@300;400;500;700&display=swap';
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

/**
 * Get margin/padding values based on direction
 */
export const getDirectionalCSS = (property, direction, language) => {
  if (language === 'ar') {
    const rtlMap = {
      left: 'right',
      right: 'left',
      marginLeft: 'marginRight',
      marginRight: 'marginLeft',
      paddingLeft: 'paddingRight',
      paddingRight: 'paddingLeft',
      borderLeft: 'borderRight',
      borderRight: 'borderLeft',
    };
    return rtlMap[direction] || direction;
  }
  return direction;
};

/**
 * Determine text alignment based on language
 */
export const getTextAlignment = (language) => {
  return language === 'ar' ? 'right' : 'left';
};

/**
 * Determine flex direction for row layouts
 */
export const getFlexDirection = (language, reverse = false) => {
  if (language === 'ar') {
    return reverse ? 'row' : 'row-reverse';
  }
  return reverse ? 'row-reverse' : 'row';
};